import messages from './cmsStandaloneCreate.json' with { type: 'json' };

export const cmsStandaloneCreateEn: Readonly<typeof messages> = messages;
